export default {
  alaskaair: {
    name: 'Alaska Airlines',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Alaska-Airlines.zip',
  },
  alliant: {
    name: 'Alliant Credit Union',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Alliant-Credit-Union.zip',
  },
  ally: {
    name: 'Ally Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Ally-Bank.zip',
  },
  amex: {
    name: 'American Express',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/American-Express.zip',
  },
  aspca: {
    name: 'ASPCA',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/ASPCA.zip',
  },
  capitalone: {
    name: 'Capital One',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Capital-One.zip',
  },
  chase: {
    name: 'Chase',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Chase-v3.zip',
  },
  citi: {
    name: 'Citi',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Citi.zip',
  },
  discover: {
    name: 'Discover',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Discover.zip',
  },
  fidelity: {
    name: 'Fidelity Investments',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Fidelity-Investments.zip',
  },
  geico: {
    name: 'Geico',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Geico.zip',
  },
  interactivebrokers: {
    name: 'Interactive Brokers',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Interactive-Brokers.zip',
  },
  lemonade: {
    name: 'Lemonade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Lemonade.zip',
  },
  lendingclub: {
    name: 'LendingClub',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/LendingClub.zip',
  },
  lightstream: {
    name: 'LightStream',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/LightStream.zip',
  },
  marriott: {
    name: 'Marriott',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Marriott-v2.zip',
  },
  navy: {
    name: 'Navy Federal Credit Union',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Navy-Federal-Credit-Union.zip',
  },
  pennymac: {
    name: 'Pennymac',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Pennymac.zip',
  },
  pnc: {
    name: 'PNC Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/PNC-Bank-v2.zip',
  },
  rate: {
    name: 'Rate',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Rate.zip',
  },
  rocket: {
    name: 'Rocket Mortgage',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Rocket-Mortgage.zip',
  },
  sofi: {
    name: 'SoFi',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/SoFi.zip',
  },
  travelers: {
    name: 'Travelers',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Travelers.zip',
  },
  ufb: {
    name: 'UFB Portfolio Savings',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/UFB-Portfolio-Savings.zip',
  },
  united: {
    name: 'United',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/United.zip',
  },
  upgrade: {
    name: 'Upgrade',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Upgrade.zip',
  },
  usbank: {
    name: 'U.S. Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/US-Bank.zip',
  },
  viobank: {
    name: 'Vio Bank',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Vio-Bank-Cornerstone-Money-Market-Savings-Account.zip',
  },
  wealthfront: {
    name: 'Wealthfront',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Wealthfront.zip',
  },
  wellsfargo: {
    name: 'Wells Fargo',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Wells-Fargo-v2.zip',
  },
  worldofhyatt: {
    name: 'World of Hyatt',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/World-of-Hyatt.zip',
  },
  wyndham: {
    name: 'Wyndham Hotels and Resorts',
    badgeLink:
      'https://www.nerdwallet.com/cdn/landing-pages/BOA-2025-partners/badges/v1/Wyndham-Hotels-and-Resorts.zip',
  },
};
